import { render, staticRenderFns } from "./DialogSearchContact.vue?vue&type=template&id=218deddb&scoped=true"
import script from "./DialogSearchContact.vue?vue&type=script&lang=js"
export * from "./DialogSearchContact.vue?vue&type=script&lang=js"
import style0 from "./DialogSearchContact.vue?vue&type=style&index=0&id=218deddb&prod&lang=scss"
import style1 from "./DialogSearchContact.vue?vue&type=style&index=1&id=218deddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218deddb",
  null
  
)

export default component.exports